import React from 'react';
import { string, oneOf } from 'prop-types';
import classnames from 'classnames/bind';

import styles from './TypeA4.css';

const cx = classnames.bind(styles);

const TypeA4 = ({ className, colorScheme, label, title, highlighted }) => (
  <div className={cx('wrapper', className, colorScheme)}>
    <p className={styles.label}>{label}</p>
    <h5 className={styles.title}>
      {highlighted && <span className={styles.highlight}>{highlighted} </span>}
      {title}
    </h5>
  </div>
);

TypeA4.propTypes = {
  colorScheme: oneOf(['pb01','lb01','lb02']),
  highlighted: string,
  className: string,
  label: string,
  title: string.isRequired
};

TypeA4.defaultProps = {
  colorScheme: 'pb01'
};

TypeA4.displayName = 'TypeA4';

export default TypeA4;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/HeroBanner/TypeA4/TypeA4.js